import React from 'react'
import { injectIntl } from 'react-intl'
import { connect } from 'react-redux'
import { Modal, Popconfirm } from 'antd'
import classnames from 'classnames'
import { closeLocaleModal, changeLocale } from 'redux/actions/settings'
import { locales } from 'locales/utils'

import style from './style.module.scss'

class LocaleSettingsModal extends React.Component {
  confirmHandler = (locale) => () => {
    this.props.changeLocale(locale)
    this.props.closeLocaleModal()
  }

  render() {
    const { locale, localeModalIsVisible, closeLocaleModal, intl: { formatMessage } } = this.props;

    return (
      <Modal
        className={style.modal}
        title={formatMessage({ id: 'components.locale-settings-modal.title' })}
        visible={localeModalIsVisible}
        footer={null}
        onCancel={closeLocaleModal}
      >
        <nav className={style.menu}>
          {Object.keys(locales).map((key) => {
            const locObj = locales[key];
            const active = key === locale;
            const language = formatMessage({ id: locObj.name })

            return (
              <Popconfirm
                key={key}
                title={formatMessage({ id: 'components.locale-settings-modal.change-confirm' }, { language })}
                onConfirm={this.confirmHandler(key)}
                okText={formatMessage({ id: 'components.locale-settings-modal.change-confirm.yes' })}
                cancelText={formatMessage({ id: 'components.locale-settings-modal.change-confirm.no' })}
                placement="bottom"
                icon={null}
                disabled={active}
              >
                <div className={classnames(style.locale, { [style.active]: active })}>
                  <img alt='' src={locObj.flag} />
                  <h3>{language}</h3>
                </div>
              </Popconfirm>
            )
          })}
        </nav>
      </Modal>
    )
  }
}

export default connect(
  ({ settings: { localeModalIsVisible, locale } }) => ({ localeModalIsVisible, locale }),
  { closeLocaleModal, changeLocale }
)(injectIntl(LocaleSettingsModal))
